import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from 'vuedraggable/dist/vuedraggable.umd';
var FORMATION_CONFIG = {
  '4-4-2': {
    key: '4-4-2',
    DEF: ['LB', 'CB', 'CB', 'RB'],
    MID: ['LM', 'CM', 'CM', 'RM'],
    FWD: ['ST', 'ST'],
    positions: [{
      code: 'GK',
      x: 300,
      y: 35,
      leftPercent: 50,
      topPercent: 9.46
    }, // 0: GK（保持原位置）
    {
      code: 'LB',
      x: 100,
      y: 115,
      leftPercent: 16.67,
      topPercent: 31.08
    }, // 1: DEF-0（保持原位置）
    {
      code: 'CB',
      x: 230,
      y: 115,
      leftPercent: 38.33,
      topPercent: 31.08
    }, // 2: DEF-1
    {
      code: 'CB',
      x: 370,
      y: 115,
      leftPercent: 61.67,
      topPercent: 31.08
    }, // 3: DEF-2
    {
      code: 'RB',
      x: 500,
      y: 115,
      leftPercent: 83.33,
      topPercent: 31.08
    }, // 4: DEF-3
    {
      code: 'LM',
      x: 100,
      y: 215,
      leftPercent: 16.67,
      topPercent: 58.11
    }, // 5: MID-0
    {
      code: 'CM',
      x: 230,
      y: 215,
      leftPercent: 38.33,
      topPercent: 58.11
    }, // 6: MID-1
    {
      code: 'CM',
      x: 370,
      y: 215,
      leftPercent: 61.67,
      topPercent: 58.11
    }, // 7: MID-2
    {
      code: 'RM',
      x: 500,
      y: 215,
      leftPercent: 83.33,
      topPercent: 58.11
    }, // 8: MID-3
    {
      code: 'ST',
      x: 220,
      y: 305,
      leftPercent: 36.67,
      topPercent: 82.43
    }, // 9: FWD-0
    {
      code: 'ST',
      x: 380,
      y: 305,
      leftPercent: 63.33,
      topPercent: 82.43
    } // 10: FWD-1
    ],
    posToGroup: [{
      posIndex: 0,
      groupKey: 'GK'
    }, {
      posIndex: 1,
      groupKey: 'DEF',
      groupIndex: 0
    }, {
      posIndex: 2,
      groupKey: 'DEF',
      groupIndex: 1
    }, {
      posIndex: 3,
      groupKey: 'DEF',
      groupIndex: 2
    }, {
      posIndex: 4,
      groupKey: 'DEF',
      groupIndex: 3
    }, {
      posIndex: 5,
      groupKey: 'MID',
      groupIndex: 0
    }, {
      posIndex: 6,
      groupKey: 'MID',
      groupIndex: 1
    }, {
      posIndex: 7,
      groupKey: 'MID',
      groupIndex: 2
    }, {
      posIndex: 8,
      groupKey: 'MID',
      groupIndex: 3
    }, {
      posIndex: 9,
      groupKey: 'FWD',
      groupIndex: 0
    }, {
      posIndex: 10,
      groupKey: 'FWD',
      groupIndex: 1
    }]
  },
  '4-3-3': {
    key: '4-3-3',
    DEF: ['LB', 'CB', 'CB', 'RB'],
    MID: ['CM', 'CDM', 'CM'],
    FWD: ['LW', 'CF', 'RW'],
    positions: [{
      code: 'GK',
      x: 300,
      y: 35,
      leftPercent: 50,
      topPercent: 9.46
    }, // 0: GK（原位置）
    {
      code: 'LB',
      x: 100,
      y: 115,
      leftPercent: 16.67,
      topPercent: 31.08
    }, // 1: DEF-0（原位置）
    {
      code: 'CB',
      x: 230,
      y: 115,
      leftPercent: 38.33,
      topPercent: 31.08
    }, // 2: DEF-1
    {
      code: 'CB',
      x: 370,
      y: 115,
      leftPercent: 61.67,
      topPercent: 31.08
    }, // 3: DEF-2
    {
      code: 'RB',
      x: 500,
      y: 115,
      leftPercent: 83.33,
      topPercent: 31.08
    }, // 4: DEF-3
    {
      code: 'CM',
      x: 200,
      y: 210,
      leftPercent: 33.33,
      topPercent: 56.76
    }, // 5: MID-0（原y=200 → 下移20）
    {
      code: 'CDM',
      x: 300,
      y: 210,
      leftPercent: 50,
      topPercent: 56.76
    }, // 6: MID-1
    {
      code: 'CM',
      x: 400,
      y: 210,
      leftPercent: 66.67,
      topPercent: 56.76
    }, // 7: MID-2
    {
      code: 'LW',
      x: 100,
      y: 300,
      leftPercent: 16.67,
      topPercent: 81.1
    }, // 8: FWD-0（原y=290 → 下移20）
    {
      code: 'CF',
      x: 300,
      y: 300,
      leftPercent: 50,
      topPercent: 81.1
    }, // 9: FWD-1
    {
      code: 'RW',
      x: 500,
      y: 300,
      leftPercent: 83.33,
      topPercent: 81.1
    } // 10: FWD-2
    ],
    posToGroup: [{
      posIndex: 0,
      groupKey: 'GK'
    }, {
      posIndex: 1,
      groupKey: 'DEF',
      groupIndex: 0
    }, {
      posIndex: 2,
      groupKey: 'DEF',
      groupIndex: 1
    }, {
      posIndex: 3,
      groupKey: 'DEF',
      groupIndex: 2
    }, {
      posIndex: 4,
      groupKey: 'DEF',
      groupIndex: 3
    }, {
      posIndex: 5,
      groupKey: 'MID',
      groupIndex: 0
    }, {
      posIndex: 6,
      groupKey: 'MID',
      groupIndex: 1
    }, {
      posIndex: 7,
      groupKey: 'MID',
      groupIndex: 2
    }, {
      posIndex: 8,
      groupKey: 'FWD',
      groupIndex: 0
    }, {
      posIndex: 9,
      groupKey: 'FWD',
      groupIndex: 1
    }, {
      posIndex: 10,
      groupKey: 'FWD',
      groupIndex: 2
    }]
  },
  '3-5-2': {
    key: '3-5-2',
    DEF: ['CB', 'CB', 'CB'],
    MID: ['LM', 'CM', 'CAM', 'CM', 'RM'],
    FWD: ['ST', 'ST'],
    positions: [{
      code: 'GK',
      x: 300,
      y: 35,
      leftPercent: 50,
      topPercent: 9.46
    }, // 0: GK（原位置）
    {
      code: 'CB',
      x: 150,
      y: 125,
      leftPercent: 25,
      topPercent: 33.78
    }, // 1: DEF-0（原y=120 → 下移10）
    {
      code: 'CB',
      x: 300,
      y: 125,
      leftPercent: 50,
      topPercent: 33.78
    }, // 2: DEF-1
    {
      code: 'CB',
      x: 450,
      y: 125,
      leftPercent: 75,
      topPercent: 33.78
    }, // 3: DEF-2
    {
      code: 'LM',
      x: 60,
      y: 212,
      leftPercent: 10,
      topPercent: 57.30
    }, // 4: MID-0（原位置）
    {
      code: 'CM',
      x: 180,
      y: 212,
      leftPercent: 30,
      topPercent: 57.30
    }, // 5: MID-1
    {
      code: 'CAM',
      x: 300,
      y: 212,
      leftPercent: 50,
      topPercent: 57.30
    }, // 6: MID-2
    {
      code: 'CM',
      x: 420,
      y: 212,
      leftPercent: 70,
      topPercent: 57.30
    }, // 7: MID-3
    {
      code: 'RM',
      x: 540,
      y: 212,
      leftPercent: 90,
      topPercent: 57.30
    }, // 8: MID-4
    {
      code: 'ST',
      x: 220,
      y: 300,
      leftPercent: 36.67,
      topPercent: 81.08
    }, // 9: FWD-0
    {
      code: 'ST',
      x: 380,
      y: 300,
      leftPercent: 63.33,
      topPercent: 81.08
    } // 10: FWD-1
    ],
    posToGroup: [{
      posIndex: 0,
      groupKey: 'GK'
    }, {
      posIndex: 1,
      groupKey: 'DEF',
      groupIndex: 0
    }, {
      posIndex: 2,
      groupKey: 'DEF',
      groupIndex: 1
    }, {
      posIndex: 3,
      groupKey: 'DEF',
      groupIndex: 2
    }, {
      posIndex: 4,
      groupKey: 'MID',
      groupIndex: 0
    }, {
      posIndex: 5,
      groupKey: 'MID',
      groupIndex: 1
    }, {
      posIndex: 6,
      groupKey: 'MID',
      groupIndex: 2
    }, {
      posIndex: 7,
      groupKey: 'MID',
      groupIndex: 3
    }, {
      posIndex: 8,
      groupKey: 'MID',
      groupIndex: 4
    }, {
      posIndex: 9,
      groupKey: 'FWD',
      groupIndex: 0
    }, {
      posIndex: 10,
      groupKey: 'FWD',
      groupIndex: 1
    }]
  },
  '5-3-2': {
    key: '5-3-2',
    DEF: ['LWB', 'CB', 'CB', 'CB', 'RWB'],
    MID: ['CM', 'CDM', 'CM'],
    FWD: ['ST', 'ST'],
    positions: [{
      code: 'GK',
      x: 300,
      y: 35,
      leftPercent: 50,
      topPercent: 9.46
    }, // 0: GK（原位置）
    {
      code: 'LWB',
      x: 80,
      y: 123,
      leftPercent: 13.33,
      topPercent: 33.24
    }, // 1: DEF-0（原y=115 → 下移15）
    {
      code: 'CB',
      x: 200,
      y: 123,
      leftPercent: 33.33,
      topPercent: 33.24
    }, // 2: DEF-1
    {
      code: 'CB',
      x: 300,
      y: 123,
      leftPercent: 50,
      topPercent: 33.24
    }, // 3: DEF-2
    {
      code: 'CB',
      x: 400,
      y: 123,
      leftPercent: 66.67,
      topPercent: 33.24
    }, // 4: DEF-3
    {
      code: 'RWB',
      x: 520,
      y: 123,
      leftPercent: 86.67,
      topPercent: 33.24
    }, // 5: DEF-4
    {
      code: 'CM',
      x: 200,
      y: 212,
      leftPercent: 33.33,
      topPercent: 57.30
    }, // 6: MID-0（原y=200 → 下移30，与上一行加大间距）
    {
      code: 'CDM',
      x: 300,
      y: 212,
      leftPercent: 50,
      topPercent: 57.30
    }, // 7: MID-1
    {
      code: 'CM',
      x: 400,
      y: 212,
      leftPercent: 66.67,
      topPercent: 57.30
    }, // 8: MID-2
    {
      code: 'ST',
      x: 220,
      y: 300,
      leftPercent: 36.67,
      topPercent: 81.1
    }, // 9: FWD-0（原位置）
    {
      code: 'ST',
      x: 380,
      y: 300,
      leftPercent: 63.33,
      topPercent: 81.1
    } // 10: FWD-1
    ],
    posToGroup: [{
      posIndex: 0,
      groupKey: 'GK'
    }, {
      posIndex: 1,
      groupKey: 'DEF',
      groupIndex: 0
    }, {
      posIndex: 2,
      groupKey: 'DEF',
      groupIndex: 1
    }, {
      posIndex: 3,
      groupKey: 'DEF',
      groupIndex: 2
    }, {
      posIndex: 4,
      groupKey: 'DEF',
      groupIndex: 3
    }, {
      posIndex: 5,
      groupKey: 'DEF',
      groupIndex: 4
    }, {
      posIndex: 6,
      groupKey: 'MID',
      groupIndex: 0
    }, {
      posIndex: 7,
      groupKey: 'MID',
      groupIndex: 1
    }, {
      posIndex: 8,
      groupKey: 'MID',
      groupIndex: 2
    }, {
      posIndex: 9,
      groupKey: 'FWD',
      groupIndex: 0
    }, {
      posIndex: 10,
      groupKey: 'FWD',
      groupIndex: 1
    }]
  },
  '4-5-1': {
    key: '4-5-1',
    DEF: ['LB', 'CB', 'CB', 'RB'],
    MID: ['LM', 'CM', 'CAM', 'CM', 'RM'],
    FWD: ['ST'],
    positions: [{
      code: 'GK',
      x: 300,
      y: 30,
      leftPercent: 50,
      topPercent: 8.11
    }, // 0: GK（原位置）
    {
      code: 'LB',
      x: 100,
      y: 115,
      leftPercent: 16.67,
      topPercent: 31.08
    }, // 1: DEF-0（原位置）
    {
      code: 'CB',
      x: 230,
      y: 115,
      leftPercent: 38.33,
      topPercent: 31.08
    }, // 2: DEF-1
    {
      code: 'CB',
      x: 370,
      y: 115,
      leftPercent: 61.67,
      topPercent: 31.08
    }, // 3: DEF-2
    {
      code: 'RB',
      x: 500,
      y: 115,
      leftPercent: 83.33,
      topPercent: 31.08
    }, // 4: DEF-3
    {
      code: 'LM',
      x: 60,
      y: 210,
      leftPercent: 10,
      topPercent: 56
    }, // 5: MID-0（原y=190 → 下移10）
    {
      code: 'CM',
      x: 180,
      y: 210,
      leftPercent: 30,
      topPercent: 56
    }, // 6: MID-1
    {
      code: 'CAM',
      x: 300,
      y: 210,
      leftPercent: 50,
      topPercent: 56
    }, // 7: MID-2
    {
      code: 'CM',
      x: 420,
      y: 210,
      leftPercent: 70,
      topPercent: 56
    }, // 8: MID-3
    {
      code: 'RM',
      x: 540,
      y: 210,
      leftPercent: 90,
      topPercent: 56
    }, // 9: MID-4
    {
      code: 'ST',
      x: 300,
      y: 300,
      leftPercent: 50,
      topPercent: 81.1
    } // 10: FWD-0
    ],
    posToGroup: [{
      posIndex: 0,
      groupKey: 'GK'
    }, {
      posIndex: 1,
      groupKey: 'DEF',
      groupIndex: 0
    }, {
      posIndex: 2,
      groupKey: 'DEF',
      groupIndex: 1
    }, {
      posIndex: 3,
      groupKey: 'DEF',
      groupIndex: 2
    }, {
      posIndex: 4,
      groupKey: 'DEF',
      groupIndex: 3
    }, {
      posIndex: 5,
      groupKey: 'MID',
      groupIndex: 0
    }, {
      posIndex: 6,
      groupKey: 'MID',
      groupIndex: 1
    }, {
      posIndex: 7,
      groupKey: 'MID',
      groupIndex: 2
    }, {
      posIndex: 8,
      groupKey: 'MID',
      groupIndex: 3
    }, {
      posIndex: 9,
      groupKey: 'MID',
      groupIndex: 4
    }, {
      posIndex: 10,
      groupKey: 'FWD',
      groupIndex: 0
    }]
  }
};
export default {
  components: {
    draggable: draggable
  },
  props: {
    teamId: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      match_id: '',
      matchInfo: {},
      formations: [FORMATION_CONFIG['4-4-2'], FORMATION_CONFIG['4-3-3'], FORMATION_CONFIG['3-5-2'], FORMATION_CONFIG['5-3-2'], FORMATION_CONFIG['4-5-1']],
      activeFormation: '4-4-2',
      currentFormation: FORMATION_CONFIG['4-4-2'],
      positionPlayers: {},
      benchPlayers: [],
      draggingPlayer: null,
      originBenchPlayers: [],
      rawBenchPlayers: [],
      // 新增：位置中英文映射字典
      positionMap: {
        'GK': '守门员',
        'LB': '左后卫',
        'CB': '中后卫',
        'RB': '右后卫',
        'LWB': '左边翼卫',
        'RWB': '右边翼卫',
        'LM': '左中场',
        'CM': '中场',
        'RM': '右中场',
        'CDM': '防守型中场',
        'CAM': '攻击型中场',
        'LW': '左边锋',
        'ST': '前锋',
        'RW': '右边锋',
        'CF': '中锋'
      },
      // 新增：固定球场尺寸基准（避免动态获取不一致）
      pitchSize: {
        width: 600,
        height: 370
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.currentFormation = this.formations.find(function (f) {
      return f.key === _this.activeFormation;
    });
  },
  methods: {
    // 新增：英文位置码转中文
    getPositionCN: function getPositionCN(posCode) {
      return this.positionMap[posCode] || posCode;
    },
    init: function init(data) {
      this.match_id = data;
      this.dialogFormVisible = true;
      this.loadLineup();
      this.getAvailablePlayersFn();
    },
    switchFormation: function switchFormation(formationKey) {
      //进行中的比赛不能换阵容
      if (this.matchInfo.status == 1 || this.matchInfo.status == 2) {
        this.$message.warning('进行中或已结束的比赛不能切换阵型');
        return;
      }

      this.activeFormation = formationKey;
      this.currentFormation = this.formations.find(function (f) {
        return f.key === formationKey;
      });
      this.positionPlayers = {}; // 核心：从 rawBenchPlayers 还原未过滤的原始替补席

      if (this.rawBenchPlayers.length > 0) {
        this.benchPlayers = JSON.parse(JSON.stringify(this.rawBenchPlayers));
        this.originBenchPlayers = JSON.parse(JSON.stringify(this.rawBenchPlayers));
      }
    },
    loadLineup: function loadLineup() {
      var _this2 = this;

      this.$api.getLineup({
        match_id: this.match_id,
        team_id: this.teamId
      }).then(function (res) {
        if (res.code == 200) {
          var _lineupList$;

          _this2.matchInfo = res.data.match_info;
          var lineupList = res.data.lineup || [];
          if (lineupList.length === 0) return; // 1. 同步阵型

          var savedFormation = ((_lineupList$ = lineupList[0]) === null || _lineupList$ === void 0 ? void 0 : _lineupList$.lineup) || '4-4-2';
          _this2.activeFormation = savedFormation;
          _this2.currentFormation = FORMATION_CONFIG[savedFormation] || FORMATION_CONFIG['4-4-2'];
          _this2.positionPlayers = {}; // 2. 终极方案：通过positions索引匹配分组（100%稳定）

          lineupList.forEach(function (player) {
            var coordinate_x = player.coordinate_x,
                coordinate_y = player.coordinate_y,
                student_id = player.student_id,
                jersey_number = player.jersey_number,
                name = player.player_name,
                avatar = player.avatar,
                player_status = player.player_status; // 找到该球员坐标对应的positions索引

            var posIndex = _this2.currentFormation.positions.findIndex(function (pos) {
              return Math.abs(pos.x - coordinate_x) < 1 && Math.abs(pos.y - coordinate_y) < 1;
            });

            if (posIndex === -1) return; // 找到positions索引对应的分组信息

            var groupMap = _this2.currentFormation.posToGroup.find(function (item) {
              return item.posIndex === posIndex;
            });

            if (!groupMap) return; // 生成posKey并赋值

            if (groupMap.groupKey === 'GK') {
              _this2.positionPlayers['GK'] = {
                student_id: student_id,
                jersey_number: jersey_number,
                name: name || '',
                avatar: avatar || '',
                coordinate_x: coordinate_x,
                coordinate_y: coordinate_y,
                player_status: player_status || 'on_field'
              };
            } else {
              var posKey = "".concat(groupMap.groupKey, "-").concat(groupMap.groupIndex);
              _this2.positionPlayers[posKey] = {
                student_id: student_id,
                jersey_number: jersey_number,
                name: name || '',
                avatar: avatar || '',
                coordinate_x: coordinate_x,
                coordinate_y: coordinate_y,
                player_status: player_status || 'on_field'
              };
            }
          }); // 3. 过滤替补席

          var linedUpStudentIds = lineupList.map(function (p) {
            return p.student_id;
          });

          if (_this2.benchPlayers.length > 0) {
            _this2.benchPlayers = _this2.benchPlayers.filter(function (p) {
              return !linedUpStudentIds.includes(p.student_id);
            });
          } else {
            _this2.linedUpStudentIds = linedUpStudentIds;
          }
        }
      });
    },
    getAvailablePlayersFn: function getAvailablePlayersFn() {
      var _this3 = this;

      this.$api.availablePlayers({
        match_id: this.match_id,
        team_id: this.teamId,
        is_all: false
      }).then(function (res) {
        if (res.code == 200) {
          var players = res.data || [];
          _this3.rawBenchPlayers = JSON.parse(JSON.stringify(players));

          if (_this3.linedUpStudentIds && _this3.linedUpStudentIds.length > 0) {
            players = players.filter(function (p) {
              return !_this3.linedUpStudentIds.includes(p.student_id);
            });
            delete _this3.linedUpStudentIds;
          }

          _this3.benchPlayers = players;
          _this3.originBenchPlayers = JSON.parse(JSON.stringify(_this3.benchPlayers));
        }
      });
    },
    onDragStart: function onDragStart(evt) {
      if (this.matchInfo.status == 2) {
        this.$message.warning('已结束的比赛不能布阵');
        return;
      }

      var playerId = evt.item.dataset.studentId;
      this.draggingPlayer = this.benchPlayers.find(function (p) {
        return p.student_id == playerId;
      });
    },
    onDragEnd: function onDragEnd(evt) {
      if (!evt.to || !this.draggingPlayer) return;
      var pitchEl = this.$refs.pitch;
      var pitchRect = pitchEl.getBoundingClientRect();
      var clientX = evt.originalEvent.clientX;
      var clientY = evt.originalEvent.clientY;
      var targetPosEl = this.getTargetPositionElement(pitchEl, clientX, clientY);

      if (!targetPosEl) {
        this.$message.warning('请将球员拖动到正确的位置区域内');
        this.draggingPlayer = null;
        return;
      }

      var posKey = targetPosEl.dataset.posKey;
      this.replacePlayer(posKey, this.draggingPlayer);
      this.draggingPlayer = null;
    },
    getTargetPositionElement: function getTargetPositionElement(pitchEl, clientX, clientY) {
      var posElements = pitchEl.querySelectorAll('.position');
      var targetEl = null;
      var minDistance = Infinity;

      for (var i = 0; i < posElements.length; i++) {
        var el = posElements[i];
        var rect = el.getBoundingClientRect();
        var elCenterX = rect.left + rect.width / 2;
        var elCenterY = rect.top + rect.height / 2;
        var distance = Math.sqrt(Math.pow(clientX - elCenterX, 2) + Math.pow(clientY - elCenterY, 2));

        if (distance < minDistance && distance < 80) {
          minDistance = distance;
          targetEl = el;
        }
      }

      return targetEl;
    },
    replacePlayer: function replacePlayer(posKey, benchPlayer) {
      var oldPlayer = this.positionPlayers[posKey];
      var standardCoord = this.getStandardCoordinate(posKey);

      var newPlayer = _objectSpread(_objectSpread({}, benchPlayer), {}, {
        coordinate_x: standardCoord.x,
        coordinate_y: standardCoord.y
      });

      if (oldPlayer) {
        this.benchPlayers.push(oldPlayer);
      }

      this.positionPlayers[posKey] = newPlayer;
      this.benchPlayers = this.benchPlayers.filter(function (p) {
        return p.student_id !== benchPlayer.student_id;
      });
    },
    removePlayer: function removePlayer(posKey) {
      var removedPlayer = this.positionPlayers[posKey];
      if (!removedPlayer) return;
      delete this.positionPlayers[posKey];
      var isAlreadyInBench = this.benchPlayers.some(function (p) {
        return p.student_id === removedPlayer.student_id;
      });

      if (!isAlreadyInBench) {
        this.benchPlayers.push(removedPlayer);
      }
    },
    getStandardCoordinate: function getStandardCoordinate(posKey) {
      if (posKey === 'GK') {
        var gkPos = this.currentFormation.positions.find(function (item) {
          return item.code === 'GK';
        });
        return {
          x: gkPos.x,
          y: gkPos.y
        };
      }

      var _posKey$split = posKey.split('-'),
          _posKey$split2 = _slicedToArray(_posKey$split, 2),
          groupKey = _posKey$split2[0],
          groupIndex = _posKey$split2[1];

      var mapItem = this.currentFormation.posToGroup.find(function (item) {
        return item.groupKey === groupKey && item.groupIndex === parseInt(groupIndex);
      });
      if (!mapItem) return {
        x: 0,
        y: 0
      };
      var posItem = this.currentFormation.positions[mapItem.posIndex];
      return {
        x: posItem.x,
        y: posItem.y
      };
    },
    getPositionStyle: function getPositionStyle(posKey) {
      var standardCoord = this.getStandardCoordinate(posKey);
      var player = this.positionPlayers[posKey];
      var xPercent = (player === null || player === void 0 ? void 0 : player.coordinate_x) ? player.coordinate_x / this.pitchSize.width * 100 : standardCoord.x / this.pitchSize.width * 100;
      var yPercent = (player === null || player === void 0 ? void 0 : player.coordinate_y) ? player.coordinate_y / this.pitchSize.height * 100 : standardCoord.y / this.pitchSize.height * 100;
      return {
        top: "".concat(yPercent, "%"),
        left: "".concat(xPercent, "%"),
        transform: 'translate(-50%, -50%)'
      };
    },
    getGroupStyle: function getGroupStyle(group) {
      return {
        position: 'absolute',
        width: '100%',
        top: this.getPositionStyle("".concat(group, "-0")).top
      };
    },
    checkLineupComplete: function checkLineupComplete() {
      if (!this.positionPlayers.GK) {
        this.$message.warning('请先配置守门员位置');
        return false;
      }

      for (var i = 0; i < this.currentFormation.DEF.length; i++) {
        if (!this.positionPlayers["DEF-".concat(i)]) {
          this.$message.warning("\u8BF7\u914D\u7F6E\u540E\u536B\u7EBF\u7B2C".concat(i + 1, "\u4E2A\u4F4D\u7F6E\uFF08").concat(this.getPositionCN(this.currentFormation.DEF[i]), "\uFF09"));
          return false;
        }
      }

      for (var _i = 0; _i < this.currentFormation.MID.length; _i++) {
        if (!this.positionPlayers["MID-".concat(_i)]) {
          this.$message.warning("\u8BF7\u914D\u7F6E\u4E2D\u573A\u7EBF\u7B2C".concat(_i + 1, "\u4E2A\u4F4D\u7F6E\uFF08").concat(this.getPositionCN(this.currentFormation.MID[_i]), "\uFF09"));
          return false;
        }
      }

      for (var _i2 = 0; _i2 < this.currentFormation.FWD.length; _i2++) {
        if (!this.positionPlayers["FWD-".concat(_i2)]) {
          this.$message.warning("\u8BF7\u914D\u7F6E\u524D\u950B\u7EBF\u7B2C".concat(_i2 + 1, "\u4E2A\u4F4D\u7F6E\uFF08").concat(this.getPositionCN(this.currentFormation.FWD[_i2]), "\uFF09"));
          return false;
        }
      }

      return true;
    },
    getCoordinateValue: function getCoordinateValue(percentStr, total) {
      var percent = parseFloat(percentStr) / 100;
      return Math.round(total * percent);
    },
    saveLineup: function saveLineup() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var lineups, _this4$pitchSize, width, height, gkStyle, i, posKey, defStyle, _i3, _posKey, midStyle, _i4, _posKey2, fwdStyle, submitData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this4.checkLineupComplete()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.prev = 2;
                lineups = [];
                _this4$pitchSize = _this4.pitchSize, width = _this4$pitchSize.width, height = _this4$pitchSize.height; // 处理守门员

                gkStyle = _this4.getPositionStyle('GK');
                lineups.push({
                  student_id: _this4.positionPlayers.GK.student_id,
                  jersey_number: _this4.positionPlayers.GK.jersey_number,
                  coordinate_x: _this4.getCoordinateValue(gkStyle.left, width),
                  coordinate_y: _this4.getCoordinateValue(gkStyle.top, height),
                  position_code: 'GK',
                  player_status: _this4.positionPlayers.GK.player_status
                }); // 处理后卫线

                for (i = 0; i < _this4.currentFormation.DEF.length; i++) {
                  posKey = "DEF-".concat(i);
                  defStyle = _this4.getPositionStyle(posKey);
                  lineups.push({
                    student_id: _this4.positionPlayers[posKey].student_id,
                    jersey_number: _this4.positionPlayers[posKey].jersey_number,
                    coordinate_x: _this4.getCoordinateValue(defStyle.left, width),
                    coordinate_y: _this4.getCoordinateValue(defStyle.top, height),
                    position_code: _this4.currentFormation.DEF[i],
                    player_status: _this4.positionPlayers[posKey].player_status
                  });
                } // 处理中场线


                for (_i3 = 0; _i3 < _this4.currentFormation.MID.length; _i3++) {
                  _posKey = "MID-".concat(_i3);
                  midStyle = _this4.getPositionStyle(_posKey);
                  lineups.push({
                    student_id: _this4.positionPlayers[_posKey].student_id,
                    jersey_number: _this4.positionPlayers[_posKey].jersey_number,
                    coordinate_x: _this4.getCoordinateValue(midStyle.left, width),
                    coordinate_y: _this4.getCoordinateValue(midStyle.top, height),
                    position_code: _this4.currentFormation.MID[_i3],
                    player_status: _this4.positionPlayers[_posKey].player_status
                  });
                } // 处理前锋线


                for (_i4 = 0; _i4 < _this4.currentFormation.FWD.length; _i4++) {
                  _posKey2 = "FWD-".concat(_i4);
                  fwdStyle = _this4.getPositionStyle(_posKey2);
                  lineups.push({
                    student_id: _this4.positionPlayers[_posKey2].student_id,
                    jersey_number: _this4.positionPlayers[_posKey2].jersey_number,
                    coordinate_x: _this4.getCoordinateValue(fwdStyle.left, width),
                    coordinate_y: _this4.getCoordinateValue(fwdStyle.top, height),
                    position_code: _this4.currentFormation.FWD[_i4],
                    player_status: _this4.positionPlayers[_posKey2].player_status
                  });
                }

                submitData = {
                  lineups: lineups,
                  team_id: Number(_this4.teamId),
                  match_id: Number(_this4.match_id),
                  lineup: _this4.activeFormation
                };
                _context.next = 13;
                return _this4.$api.lineup(submitData).then(function (res) {
                  if (res.code == 200) {
                    _this4.$message.success("布阵保存成功");

                    _this4.dialogFormVisible = false;
                  } else {
                    _this4.$message.error(res.msg);
                  }
                });

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);

                _this4.$message.error('保存失败，请重试！');

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 15]]);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      this.positionPlayers = {};
      this.benchPlayers = [];
      this.originBenchPlayers = [];
    },
    selectPlayer: function selectPlayer() {}
  }
};